<div class="rs-maxh rs-padding-bottom2">
  <div
    *ngIf="accountStatusFetching || accountStatusError"
    class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh rs-flex rs-flex-dir-col rs-overflow-hidden"
  >
    <div class="rs-flex-row">
      <div class="rs-flex-columns">
        <h3 class="rs-tit6">{{ 'cloud.access.active.title' | translate }}</h3>
      </div>
      <div class="rs-flex-columns" *ngIf="accountStatusFetching">
        <px-loading-spinner></px-loading-spinner>
        <span class="show-for-sr">{{
          'cloud.access.active.spinner.accessibility' | translate
        }}</span>
      </div>
      <px-alert [alertKey]="'cloudStatusAlert'"></px-alert>
    </div>
  </div>
  <div
    *ngIf="accountActive && accountStatusFetchedSuccess"
    class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh rs-flex rs-flex-dir-col rs-overflow-hidden"
  >
    <h3 class="rs-tit6">{{ 'cloud.access.active.title' | translate }}</h3>
    <div class="rs-padding-bottom1">
      <div class="rs-flex-row">
        <div class="rs-flex-columns">
          <p class="rs-padding-bottom1">
            {{ 'cloud.access.active.login' | translate }}
          </p>
        </div>
        <div class="rs-flex-columns">
          <p class="rs-padding-bottom1 rs-word-break-all">
            <strong>{{ login || loginFallback }}</strong>
          </p>
        </div>
      </div>
      <div class="rs-flex-row">
        <div class="rs-flex-columns">
          <p class="rs-padding-bottom1">
            {{ 'cloud.access.active.web.label' | translate }}
          </p>
        </div>
        <div class="rs-flex-columns" style="padding-right: 0">
          <p class="rs-padding-bottom1 rs-word-break-all">
            <a
              href="{{ 'cloud.access.active.web.link.path' | translate }}"
              target="_blank"
              data-tms-event="link-click"
              attr.data-tms-link-zone="{{ 'cloud.access.active.title' | translate }}"
              attr.data-tms-link-name="{{ 'cloud.access.active.web.link.label' | translate }}"
              attr.data-tms-link-url="{{ 'cloud.access.active.web.link.path' | translate }}"
              >{{ 'cloud.access.active.web.link.label' | translate
              }}<span class="rs-icon-link-tb" title="Opens a new window"
                ><span class="show-for-sr">{{
                  'cloud.access.active.web.link.openWindow.accessibility' | translate
                }}</span></span
              ></a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="!accountActive && accountStatusFetchedSuccess"
    class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh rs-flex rs-flex-dir-col"
  >
    <h3 class="rs-tit6">{{ 'cloud.access.activation.title' | translate }}</h3>
    <px-alert [alertKey]="'cloudActivationAlert'"></px-alert>
    <div class="rs-form-item">
      <div class="rs-checkbox">
        <input
          type="checkbox"
          name="check10"
          id="ac-check10"
          required=""
          [(ngModel)]="tncAccepted"
          (click)="toggleTnc()"
        /><label
          for="ac-check10"
          [innerHTML]="'cloud.access.activation.tnc' | translate: true"
        ></label>
      </div>
    </div>
    <div class="rs-flex-grow rs-flex rs-flex-bottom">
      <div class="rs-maxw">
        <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
          <div class="rs-flex-columns">
            <button
              class="rs-btn"
              id="activateBtn"
              [disabled]="!tncAccepted || accountActivationSuccess || accountActivationError"
              [ngClass]="
                (!tncAccepted || accountActivationSuccess || accountActivationError) &&
                'rs-btn-disabled'
              "
              data-tms-event="button-click"
              attr.data-tms-button-zone="{{ 'cloud.access.active.title' | translate }}"
              attr.data-tms-button-name="{{ 'cloud.access.activation.button' | translate }}"
              (click)="activate()"
            >
              {{ 'cloud.access.activation.button' | translate }}
            </button>
          </div>
          <!-- To display only when spinner is loading -->
          <div class="rs-flex-columns" *ngIf="accountActivationPending">
            <div class="text-center rs-margin-bottom2">
              <px-loading-spinner></px-loading-spinner>
              <span class="show-for-sr">{{
                'cloud.access.activation.spinner.accessibility' | translate
              }}</span>
            </div>
          </div>
          <!-- End Spinner -->
        </div>
      </div>
    </div>
  </div>
</div>
